import { airTricks, type AirTricksComp } from "../components/airTricks";
import { cameraFollow } from "../components/cameraFollow";
import { depth } from "../components/depth";
import { hops } from "../components/hops";
import { look } from "../components/look";
import { mountainTracker } from "../components/mountainTracker";
import { obstacleHits } from "../components/obstacleHits";
import { shadowOf } from "../components/shadowOf";
import { playerInput } from "../components/playerInput";
import { RIDER_STATES, rider, type Rider, type RiderState } from "../components/rider";
import { takeoff, type TakeoffComp } from "../components/takeoff";
import { config } from "../config";
import { k } from "../core/kaplay";
import type { RunState } from "../core/runState";
import type { Mountain } from "../systems/mountain";
import type { SurfaceRegion } from "../systems/surface";

export type Player = Rider & AirTricksComp & TakeoffComp;

export function addPlayer(run: RunState, mountain: Mountain, regions: () => SurfaceRegion[]): Player {
    return k.add([
        k.pos(0, 0),
        look("player"),
        k.area({ shape: new k.Rect(k.vec2(-20, -32), 40, 32), isSensor: true }),
        k.opacity(1),
        k.rotate(0),
        k.scale(1),
        k.z(0),
        depth(),
        playerInput(),
        k.state<RiderState>("riding", RIDER_STATES),
        rider(run),
        takeoff(),
        hops(run),
        airTricks(run),
        obstacleHits(config.modes.modes[run.mode]),
        mountainTracker(run, mountain, regions),
        cameraFollow(),
        "player",
        "world",
    ]) as unknown as Player;
}

export function addShadow(player: Rider) {
    return k.add([k.pos(player.pos), look("shadow"), k.opacity(0), k.scale(1), k.layer("ground"), k.z(3), shadowOf(player), "world"]);
}
